import script from "./SingleQuote.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleQuote.vue?vue&type=script&setup=true&lang=js"

import "./SingleQuote.vue?vue&type=style&index=0&id=01ac4832&lang=css"

const __exports__ = script;

export default __exports__